<template>
  <v-dialog

      v-model="logout"
            persistent
            max-width="450px">

      <v-card style="border-radius: 5px;  "  flat color="#f0f8ff"  elevation="12" class="fill-height">
        <v-card-title   >
          <div style="text-align: center">
            خروج
          </div>


        </v-card-title>
        <v-spacer/>
<v-card-subtitle>آیا می خواهید خارج شوید؟</v-card-subtitle>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="error"
                  class=" pr-10 pl-10 mr-2"
                  @click="logoutUser()"
              >
                بله
              </v-btn>
              <v-btn
                  color="primary"
                 small
                 depressed

                  class=" pr-10 pl-10"
                  @click="cancel()"
              >
                خیر
              </v-btn>
            </v-card-actions>


      </v-card>
<!--    </div>-->
  </v-dialog>
</template>

<script>



import auth from "../../../services/Api";

export default {

  props: {
    logout: {
      default: false,
    },
  },
  methods: {

    logoutUser() {
      auth.logout(),
          this.$router.push('/login')
      this.$emit('update:logout', false)
    },
cancel(){
      this.logout=false
  this.$emit('update:logout', false)
}

  },


}
</script>


